const configs = {
    isAdmin: 4,
    isSuperAdmin: 3
};
export default configs;
